import { render, staticRenderFns } from "./FotoTab.vue?vue&type=template&id=62389d74&scoped=true"
import script from "./FotoTab.vue?vue&type=script&lang=js"
export * from "./FotoTab.vue?vue&type=script&lang=js"
import style0 from "./FotoTab.vue?vue&type=style&index=0&id=62389d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62389d74",
  null
  
)

export default component.exports